import Vue from "vue";
import app from "@/main";

async function getData( loadingName, url, params ) {
	if ( loadingName ) {
		app.$wait.start( loadingName );
	}

	try {
		return ( await Vue.axios.get( url, { params } ) ).data;
	} finally {
		if ( loadingName ) {
			app.$wait.end( loadingName );
		}
	}
}

export const getBreadcrumbs = requestData => getData( "getBreadcrumbs", "breadcrumbs", { data: requestData } );

export const getDriverTimeOff = ( idDriver, idTimeOff, isPageModel ) => getData(
	"getDriverTimeOff",
	`yard/drivers/${idDriver}/time-off/${idTimeOff}`,
	{ isPageModel }
);
export const getDriverTimesOff = idDriver => getData( "getDriverTimesOff", `yard/drivers/${idDriver}/time-off` );
export const getDriversTimesOff = () => getData( "getDriversTimesOff", "yard/drivers/time-off" );

export const getPreTrip = ( idTruck, idPreTrip ) => getData( "getPreTrip", `yard/trucks/${idTruck}/pretrips/${idPreTrip}` );
export const getPreTrips = idTruck => getData( "getPreTrips", `yard/trucks/${idTruck}/pretrips` );
